
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Ebene_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 124 124","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st0",attrs:{"cx":"62","cy":"62","r":"62"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"62","cy":"62","r":"62"}}),_c('path',{staticClass:"st1",attrs:{"d":"M60 100.6c-13.5-.4-26.4-6.2-36.5-17.9-2-2.3-1.9-5 .1-6.8 2-1.8 4.7-1.4 6.7.9 9 10.3 20.3 15.3 34 14.6 11.5-.6 21.1-5.5 28.7-14 .7-.8 1.6-1.7 2.5-2.2 1.8-.9 4-.2 5.3 1.4 1.3 1.7 1.2 4-.2 5.7-3.6 4.3-7.7 8-12.5 10.9-8 4.9-16.7 7.3-28.1 7.4zM100.2 47.9v1.8c-.1 2.5-2 4.4-4.4 4.4-2.4 0-4.4-1.9-4.6-4.3-.1-1 .1-2-.1-3-.2-.8-.6-1.8-1.2-2.4-1.8-1.5-5.1-1.5-7-.1-.9.6-1.4 1.5-1.3 2.6v2.7c-.1 2.4-1.9 4.3-4.3 4.4-2.3.1-4.4-1.7-4.7-4-.9-6.9 2.1-12.4 8.2-14.7 6.4-2.5 13.8-.4 17.4 4.9 1.5 2.2 2 4 2 7.7zM23.9 47.7c-.8-9 8.6-15.1 17.7-12.8 4.8 1.2 10.3 5.3 10 12.8-.1 1.1 0 2.2-.2 3.2-.5 2.1-2.6 3.5-4.7 3.3-2.3-.2-4-2-4.1-4.3 0-.9-.1-1.8 0-2.7.1-1.4-.6-2.3-1.8-3-1.6-.9-3.3-1-5.1-.5-2.1.6-2.8 1.6-2.8 3.8v2.1c-.1 2.6-2.1 4.5-4.5 4.5-2.5 0-4.5-2-4.5-4.6-.1-.6 0-1.2 0-1.8z"}})])
          )
        }
      }
    